import { siFacebook, siInstagram, siTiktok, siYoutube } from 'simple-icons';

// Los logos reales de cada red (Simple Icons: la marca oficial en un solo trazo,
// no un emoji) — pedido explícito de Javier, 28/09/2026. Colores de marca oficiales.
const ICONOS = {
  INSTAGRAM: siInstagram,
  TIKTOK: siTiktok,
  FACEBOOK: siFacebook,
  YOUTUBE: siYoutube,
} as const;

export type RedConLogo = keyof typeof ICONOS;

export function RedSocialIcon({
  red,
  size = 14,
  className,
}: {
  red: RedConLogo;
  size?: number;
  className?: string;
}): JSX.Element {
  const icono = ICONOS[red];
  // Decorativo: siempre va al lado de texto o de un title/aria-label del control
  // que lo contiene (el checkbox de al lado, el title del botón) — darle su
  // propio aria-label duplicaba el nombre accesible y rompía los tests.
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} className={className} aria-hidden="true">
      <path d={icono.path} fill={`#${icono.hex}`} />
    </svg>
  );
}
